// Single source of truth for route paths. Use builders for params.
export const paths = {
  login: '/login',
  authCallback: '/auth/callback',
  workspaces: '/workspaces',
  workspace: (id = ':workspaceId') => `/workspaces/${id}`,
  workspaceSettings: (id = ':workspaceId') => `/workspaces/${id}/settings`,
  codex: (workspaceId = ':workspaceId', codexId = ':codexId') =>
    `/workspaces/${workspaceId}/codices/${codexId}`,
};
